import React from "react";
import { StyleSheet, View } from "react-native";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { TrashIcon, WarningCircleIcon } from "@phosphor-icons/react";

const DeleteTaskConfirmation = ({ visible, onClose, onConfirm, task = null, loading = false }) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose}>
      <View style={styles.header}>
        <View style={styles.iconContainer}>
          <WarningCircleIcon size={24} color="#F04438" weight="fill" />
        </View>
        <CustomText style={styles.title} text="Delete Task" useTranslationText={false} />
      </View>

      <View style={styles.content}>
        <CustomText
          style={styles.message}
          text="Are you sure you want to delete this task?"
          useTranslationText={false}
        />

        {task && (
          <View style={styles.taskInfo}>
            <CustomText style={styles.taskTitle} text={task.title} useTranslationText={false} />
            {task.description && (
              <CustomText style={styles.taskDescription} text={task.description} useTranslationText={false} />
            )}
          </View>
        )}

        <CustomText style={styles.warning} text="This action cannot be undone." useTranslationText={false} />
      </View>

      <View style={styles.footer}>
        <CustomButton
          text="Cancel"
          size="m"
          styleType="secondary"
          onPress={onClose}
          style={styles.cancelButton}
          disabled={loading}
        />
        <CustomButton
          text="Delete Task"
          size="m"
          styleType="danger"
          onPress={onConfirm}
          loading={loading}
          style={styles.deleteButton}
          icon={<TrashIcon size={16} color="#ffffff" />}
        />
      </View>
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  header: {
    alignItems: "center",
    paddingTop: 24,
    paddingHorizontal: 24,
    paddingBottom: 16,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: "rgba(240, 68, 56, 0.1)",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    color: "#101828",
    textAlign: "center",
  },
  content: {
    paddingHorizontal: 24,
    paddingBottom: 24,
  },
  message: {
    fontSize: 16,
    color: "#667085",
    textAlign: "center",
    marginBottom: 16,
    lineHeight: 24,
  },
  taskInfo: {
    backgroundColor: "#F9FAFB",
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: "#EAECF0",
  },
  taskTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#101828",
    marginBottom: 8,
  },
  taskDescription: {
    fontSize: 14,
    color: "#667085",
    lineHeight: 20,
  },
  warning: {
    fontSize: 14,
    color: "#F04438",
    textAlign: "center",
    fontWeight: "500",
  },
  footer: {
    flexDirection: "row",
    paddingHorizontal: 24,
    paddingBottom: 24,
    gap: 12,
  },
  cancelButton: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderColor: "#EAECF0",
    borderWidth: 1,
  },
  deleteButton: {
    flex: 1,
    backgroundColor: "#F04438",
  },
});

export default DeleteTaskConfirmation;
